import React from 'react';
import PropTypes from 'prop-types';
import LabeledIconButton from '@components/buttons/labeled-icon-btn/LabeledIconButton';

import './UndoRedoTool.scss';

const UndoRedoTool = ({
  canUndo,
  canRedo,
  undo,
  redo,
}) => {
  return (
    <div className="undo-redo-tool">
      <div className="undo-redo-button-group">
          <LabeledIconButton iconId="undo" locKey="qau-undo-btn" onClick={undo} disabled={!canUndo} />
          <LabeledIconButton iconId="redo" locKey="qau-redo-btn" onClick={redo} disabled={!canRedo} />
      </div>
    </div>
  )
}

UndoRedoTool.propTypes = {
  canUndo: PropTypes.bool.isRequired,
  canRedo: PropTypes.bool.isRequired,
  undo: PropTypes.func.isRequired,
  redo: PropTypes.func.isRequired,
};

export default UndoRedoTool;